import axios, { getData } from 'lib/axios'

export const getSubmission = (id) => {
    return axios.get(`/performance/submissions/${id}`).then(getData)
}

export const getAllSubmission = (staffId, evaluationId) => {
    return axios.get(`/performance/${staffId}/submission/${evaluationId}`).then(getData)
}

export const sendSubmission = (id, data) => {
    return axios.put(`/performance/submissions/${id}`, data).then(getData)
}

